export default __webpack_public_path__ + "static/media/duke-campus.cdbc5f82.jpg";